module.exports = __webpack_public_path__ + "static/img/img-install-tag-car-grid.fe7d20b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-car-grid.svg
// module id = 1789
// module chunks = 1